import apiService from './api-service'

const colabsService = {}

/**
 * Retrieve a colabs by it's id
 * @param  array params (optional)
 * @return colabs
 */
colabsService.list = function (params) {
  return apiService.get(`/colaborators`, { params }).then(res => res.data)
}

/**
 * Retrieve a colabs minified by it's id
 * @param  array params (optional)
 * @return colabs
 */
colabsService.listSelect = function (params) {
  return apiService.get(`/colaborators-select`, { params }).then(res => res.data)
}

/**
 * Retrieve a colabs by it's id
 * @param  int id
 * @param  array params (optional)
 * @return colabs
 */
colabsService.getById = function (id) {
  return apiService.get(`/colaborators/${id}`, { id }).then(res => res.data).catch(error => error)
}

/**
 * Update a colabs by it's id
 * @param  int id
 * @param  array params (optional)
 * @return colabs
 */
colabsService.updateById = function (id, body) {
  body['_method'] = 'PUT'
  return apiService.put(`/colaborators/${id}`, body).then(res => res.data)
}

/**
 * Create a promoters by it's id
 * @param  object body
 * @return promoters
 */
colabsService.post = function (body) {
  return apiService.post(`/colaborators`, body).then(res => res.data)
}

/**
 * Retrieve all positions codes
 * @param  object params
 * @return status' list
 */
colabsService.getPositionsList = function (params) {
  return apiService.get(`/colaborators/positions`, { params }).then(res => res.data)
}

/**
 * Retrieve all accounts codes
 * @param  object params
 * @return status' list
 */
colabsService.getAccountsList = function (id) {
  return apiService.get(`/colaborators/${id}/accounts`, { id }).then(res => res.data)
}

/**
 * Retrieve all savings codes
 * @param  object params
 * @return status' list
 */
colabsService.getSavingsAccountsList = function (id) {
  return apiService.get(`/colaborators/${id}/savings_accounts`, { id }).then(res => res.data)
}

/**
 * Retrieve a account by it's id
 * @param  int id
 * @param  array params (optional)
 * @return account
 */
colabsService.getAccountById = function (id) {
  return apiService.get(`/accounts/${id}`, { id }).then(res => res.data).catch(error => error)
}

/**
 * Create an account by it's id
 * @param  int id
 * @param  array params (optional)
 * @return status
 */
colabsService.addAccount = function (body) {
  return apiService.post(`/accounts`, body).then(res => res.data)
}

/**
 * Update a colabs by it's id
 * @param  int id
 * @param  array params (optional)
 * @return colabs
 */
colabsService.updateAccount = function (id, body) {
  body['_method'] = 'PUT'
  return apiService.put(`/accounts/${id}`, body).then(res => res.data)
}

colabsService.getStatement = function (id) {
  return apiService.get(`/statement-colaborator/${id}`).then(res => res.data)
}

export default colabsService



// WEBPACK FOOTER //
// ./src/services/colaborators.js